// @flow
export const AVAILABLE_PRODUCT_BATCH_LOAD_FORMATS = [
  'json',
  'xlsx',
  'xls',
  'csv',
];

export type BatchUploadState = 'PENDING' | 'DONE' | 'FAILED' | 'empty';

export type CreateBatchProductsRequest = {
  fileId: string,
};
export type ProductBatchLoadResult = {
  scope: 'PRODUCTS' | 'PRODUCT_VARIANTS' | 'BULK_PRICES',
  index: number,
  message: string,
  field?: string,
  type?: 'not_found' | 'type' | 'missing',
};

export type ProductBatchLoadErrorResult = {
  errorName: string,
  detail: string,
};
export type ProductBatchLoadTask = {
  createdAt: number,
  id: string,
  result: ProductBatchLoadResult[] | ProductBatchLoadErrorResult,
  state: BatchUploadState,
  type: 'batch-product-task',
  updatedAt: number,
};
